export const checkApiError = async (response: Response) => {
  if (!response.ok) {
    let errorMessage = `Request failed: ${response.statusText}`;
    try {
      const errorData = await response.json();
      if (
        typeof errorData === "object" &&
        errorData !== null &&
        "message" in errorData &&
        typeof errorData.message === "string"
      ) {
        errorMessage = errorData.message;
      }
    } catch (jsonError) {
      console.warn("Could not parse error response JSON:", jsonError);
    }
    throw new Error(errorMessage);
  }
};
